/** Grows with the tallest column. Do not lock this to the viewport. */
export const KANBAN_BOARD_CLASSNAME =
  'relative flex w-full min-h-full flex-1 items-stretch auto-rows-auto grid-cols-none gap-4 overflow-x-auto overflow-y-visible pb-2 sm:grid-cols-none';

export const KANBAN_COLUMN_SHELL_CLASSNAME =
  'board-column relative flex h-auto min-h-full flex-1 flex-col rounded-[14px] border border-border bg-muted/40 px-2 py-2 transition-colors duration-150 ease-out motion-reduce:transition-none';
